'use client'

import Script from 'next/script'
import { useParams } from 'next/navigation'
import { useEffect } from 'react'

export default function ClientScripts() {
  const params = useParams()
  const locale = params.locale as string

  useEffect(() => {
    // Initialize font loading optimization
    import('@/lib/font-loading').then(({ preloadCriticalFonts, FontPerformanceMonitor }) => {
      // Start font performance monitoring
      const monitor = new FontPerformanceMonitor()
      monitor.startTracking('AeonikPro')
      
      // Preload critical fonts for the current locale
      preloadCriticalFonts(locale)
      
      // Report metrics after fonts are loaded (for development)
      if (process.env.NODE_ENV === 'development') {
        setTimeout(() => monitor.reportMetrics(), 3000)
      }
    }).catch(console.warn)
  }, [locale])

  return (
    <Script
      src="https://cdn.jsdelivr.net/npm/lozad/dist/lozad.min.js"
      strategy="afterInteractive"
      onLoad={() => {
        // Initialize lozad and performance monitoring after loading
        if (typeof window !== 'undefined') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if ((window as any).lozad) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).lozad('.lozad', {
              threshold: 0.1,
              enableAutoReload: true
            }).observe();
          }

          // Initialize performance monitoring
          import('@/lib/performance-monitor').then(({ initializePerformanceMonitoring }) => {
            initializePerformanceMonitoring();
          }).catch(console.warn);
        }
      }}
    />
  )
}